import { getUserPreferences } from "./userPreferences";

const WEEKDAY_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTH_SHORT = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

/** e.g. `Quick Campaign - 20 Jul 2026 (Mon)` */
export function formatQuickCampaignName(date = new Date()) {
    const day = date.getDate();
    const month = MONTH_SHORT[date.getMonth()];
    const year = date.getFullYear();
    const weekday = WEEKDAY_SHORT[date.getDay()];

    return `Quick Campaign - ${day} ${month} ${year} (${weekday})`;
}

/** Defaults for quick-post campaigns; overridden by per-user preferences in localStorage. */
export function getQuickCampaignDefaults(userId) {
    const prefs = getUserPreferences(userId);

    return {
        name: formatQuickCampaignName(),
        platform: prefs.platform,
        language: prefs.language,
    };
}

export function getDefaultTarget(userId) {
    return getUserPreferences(userId).target;
}
